import sysConfig from '@/config'
import JSEncrypt from 'jsencrypt'
import CryptoJS from 'crypto-js'
/**
 * 格式时间
 * @param {*} second 秒
 */
export function recordTimeFormat(second) {
  // console.log(second);
  second = parseInt(second)
  let MM, HH, SS
  let formatTime
  SS = second % 60
  MM = Math.floor(second / 60)
  // eslint-disable-next-line prefer-const
  HH = Math.floor(MM / 60)
  MM = MM % 60
  if (MM < 10) MM = '0' + MM
  if (SS < 10) SS = '0' + SS
  formatTime = MM + ':' + SS
  if (HH > 0) formatTime = HH + ':' + formatTime
  return formatTime.split('.')[0]
}
/**
 * 格式化时间
 * @param date
 * @param format
 */
export function formatTime(date, format = 'yyyy-MM-dd_hh-mm-ss') {
  const padLeftZero = str => {
    return ('00' + str).substr(str.length)
  }
  // 用正则表达式
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      const str = o[k] + ''
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return format
}
/**
 * 把播放的时间秒转换成时分秒
 * @param second
 */
export function realFormatSecond(second = 0) {
  var secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)

    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    if (hours > 0) {
      return (
        hours +
        ':' +
        ('0' + mimute).slice(-2) +
        ':' +
        ('0' + second).slice(-2)
      )
    } else return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

// 获取参数
export function getQueryString(name, href) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = href ? href.match(reg) : window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export function _isMobile() {
  const match = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|Symbian|Windows Phone)/i
  )
  const flag = match || (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 && navigator.userAgent.toLowerCase().indexOf('mobile') !== -1)
  return flag
}

export function _isIphone() {
  // iPhone X、iPhone XS
  const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
  // iPhone XS Max
  const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
  // iPhone XR
  const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896
  const flag = isIPhoneX || isIPhoneXSMax || isIPhoneXR
  return flag
}

export function _isWeixinBrowser() {
  const flag = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  return flag
}
export function getTimeByTimeZone(time, timeZone = 8) {
  const d = new Date()
  const localOffset = d.getTimezoneOffset() * 60000 // 获得当地时间偏移的毫秒数,这里可能是负数
  const utc = time + localOffset // utc即GMT时间
  const offset = timeZone // 时区，北京市+8  美国华盛顿为 -5
  const localSecondTime = utc + (3600000 * offset) // 本地对应的毫秒数
  const date = new Date(localSecondTime)
  // console.log("根据本地时间得知" + timeZone + "时区的时间是 " + date);
  // console.log('系统默认展示时间方式是：' + new Date(localSecondTime))
  return date
}
/*
* 字符串md5
*/
export function md5Encrypt(plaintext) {
  return CryptoJS.MD5(plaintext).toString()
}
/*
* 字符串sha256
*/
export function sha256Encrypt(plaintext) {
  plaintext = CryptoJS.SHA256(plaintext).toString()
  return plaintext
}
/**
 * 生成随机数
 */
export function randomString(size) {
  size = size || 6
  const code_string = '0123456789'
  const max_num = code_string.length + 1
  let new_pass = ''
  while (size > 0) {
    new_pass += code_string.charAt(Math.floor(Math.random() * max_num))
    size--
  }
  return new_pass
}
export function removePropertyOfNull(obj) {
  const newObj = JSON.parse(JSON.stringify(obj))
  if (newObj.searchDate) delete newObj.searchDate
  if (newObj.searchStage) delete newObj.searchStage
  Object.keys(newObj).forEach(item => {
    if (!newObj[item]) delete newObj[item]
  })
  return newObj
}
export function encrypt(txt, mode) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(mode ? sysConfig.USER.RSA_PUBLICKEY : sysConfig.APP.RSA_PUBLICKEY)
  return encryptor.encrypt(txt)
}
export function decrypt(rsaDta) {
  const decryptor = new JSEncrypt()
  decryptor.setPrivateKey(sysConfig.USER.RSA_PRIVATE)
  const data = decryptor.decrypt(rsaDta)
  return data
}
// DES加密 Pkcs7填充方式
export function encryptByDES(text, key, iv = '0000000000000000') {
  iv = CryptoJS.enc.Utf8.parse(iv)
  text = CryptoJS.enc.Utf8.parse(text)
  key = CryptoJS.enc.Utf8.parse('1234567890123456')
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  console.log(encrypted.toString())
  return encrypted.toString()
}
// DES解密 Pkcs7填充方式
export function decryptByDes(text, key, iv) {
  iv = CryptoJS.enc.Utf8.parse(iv)
  const encryptedHexStr = CryptoJS.enc.Hex.parse(text)
  text = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  key = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.AES.decrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString(CryptoJS.enc.Utf8)
}
// 进入全屏
export function enterFullscreen() {
  const element = document.documentElement
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.msRequestFullscreen) {
    // IE11
    element.msRequestFullscreen()
  }
}
// 退出全屏
export function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}
export function hightLightChart(chart, currentIndex) {
  chart.dispatchAction({
    type: 'downplay',
    seriesIndex: 0,
    dataIndex: currentIndex
  })
  chart.dispatchAction({
    type: 'showTip', // 默认显示江苏的提示框
    seriesIndex: 0, // 这行不能省
    dataIndex: currentIndex
  })
  chart.dispatchAction({
    type: 'highlight',
    seriesIndex: 0,
    dataIndex: currentIndex
  })
}
// 生成uuid
export function uuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    var r
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

export const getdate=(val)=>{
  var unixtimestamp = new Date(val*1000);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  var hour = "0" + unixtimestamp.getHours();
  var minute = "0" + unixtimestamp.getMinutes();
  var second = "0" + unixtimestamp.getSeconds();
  return year + "-" + month.substring(month.length-2, month.length)  + "-" + date.substring(date.length-2, date.length)

};
export const getdate1=(val)=>{
  var unixtimestamp = new Date(val*1000);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  var hour = "0" + unixtimestamp.getHours();
  var minute = "0" + unixtimestamp.getMinutes();
  var second = "0" + unixtimestamp.getSeconds();
  return year + "-" + month.substring(month.length-2, month.length)  + "-" + date.substring(date.length-2, date.length)+' '+hour.substring(hour.length-2, hour.length)+':'+minute.substring(minute.length-2, minute.length)+':'+second.substring(second.length-2, second.length)
};

export const formDate=()=>{
  let date = new Date(),
  Y = date.getFullYear(),
  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1),
  D = date.getDate()>9?date.getDate():'0'+date.getDate();
  return Y+'-'+M+'-'+D;
}

export const formDateTime=()=>{
  let date = new Date(),
      Y = date.getFullYear(),
      M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1),
      D = date.getDate()>9?date.getDate():'0'+date.getDate(),
      h = date.getHours()>9?date.getHours():'0'+date.getHours(),
      m = date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes(),
      s = date.getSeconds()>9?date.getSeconds():'0'+date.getSeconds();
  return Y+'-'+M+'-'+D+' '+h+':'+m+':'+s;
}


export const getAge=(strAge)=>{
  var birArr = strAge.split("/");
  var birYear = birArr[0];
  var birMonth = birArr[1];
  var birDay = birArr[2];
  d = new Date();
  var nowYear = d.getFullYear();
  var nowMonth = d.getMonth() + 1; //记得加1
  var nowDay = d.getDate();
  var returnAge;

  if (birArr == null) {
      return false
  };
  var d = new Date(birYear, birMonth - 1, birDay);
  if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
      if (nowYear == birYear) {
          returnAge = 0; // 
      } else {
          var ageDiff = nowYear - birYear; // 
          if (ageDiff > 0) {
              if (nowMonth == birMonth) {
                  var dayDiff = nowDay - birDay; // 
                  if (dayDiff < 0) {
                      returnAge = ageDiff - 1;
                  } else {
                      returnAge = ageDiff;
                  }
              } else {
                  var monthDiff = nowMonth - birMonth; // 
                  if (monthDiff < 0) {
                      returnAge = ageDiff - 1;
                  } else {
                      returnAge = ageDiff;
                  }
              }
          } else {
              return  {status:0,msg:"出生日期晚于今天，数据有误"}; //返回-1 表示出生日期输入错误 晚于今天
          }
      }
      return  {status:1,msg:"操作成功",data:returnAge};
  } else {
      return  {status:0,msg:"输入的日期格式错误！"};
  }
}


export const _isJSON=(str)=>{
  if (typeof str == 'string') {
      try {
          var obj = _parseJSON(str);
          if(typeof obj == 'object' && obj ){
              return true;
          }else{
              return false;
          }

      } catch(e) {
          return false;
      }
  }else if(typeof str == 'object'){
      return true;
  }else{
      return false;
  }
}


export const iconList=[
  'icon-svg-','icon-wangzhi_huaban','icon-jigou','icon-jigouguanli','icon-kaohe','icon-kecheng',
  'icon-kecheng-','icon-shezhipingji','icon-jigou1','icon-government','icon-qizhi','icon-zhengfu',
  'icon-icon','icon-gonggao','icon-shouye','icon-xiaoxi','icon-zuoye','icon-anquan','icon-liuyan1',
  'icon-ziyuan','icon-yonghuxinxi','icon-message','icon-chaxun','icon-kaoshi','icon-icon_xinyong_xianxing_jijin-','icon-xitong',
  'icon-shenfenzhengfanmian','icon-shenfenzhengzhengmian','icon-quanyuanxuanjiao','icon-peixun','icon-kaoshi','icon-zhengce','icon-zhongxinjianjie',
  'icon-caozuo_liangdu','icon-kaoshiguanli', 'icon-kaoshidagang', 'icon-peixunchaxun', 'icon-peixundagang', 'icon-shishijiankong', 'icon-xitongshezhi', 'icon-guiding', 'icon-yongpin', 'icon-jianjie'
  , 'icon-shenbao', 'icon-jiaofei'
]
export const roleList=[
  {name:'个人端',role:0,active:false},
  {name:'机构端',role:1,active:false},
  {name:'监管端',role:2,active:false},
  {name:'企业端',role:3,active:false},
  {name:'总账号',role:4,active:true},
  {name:'back端',role:5,active:true},
]


export const getDateYearSub=(startDateStr, endDateStr)=>{
  var m1 = parseInt(startDateStr.split("-")[1].replace(/^0+/, "")) + parseInt(startDateStr.split("-")[0]) * 12;
  var m2 = parseInt(endDateStr.split("-")[1].replace(/^0+/, "")) + parseInt(endDateStr.split("-")[0]) * 12;
var diff = m2 - m1;
return diff==0?0.1:(diff/12).toFixed(1);
}

export const orderType=[{odtype:'TZZY',title:'特种作业'},{odtype:'TZSD',title:'特种设备'},{odtype:'SCJY',title:'负责人安全员'},{odtype:'WHQY',title:'危化企业'},{odtype:'JNTS',title:'技能提升'}];
export const orderTypeMap = {
  'TZZY': '特种作业',
  'TZSD': '特种设备',
  'SCJY': '生产企业',
  'WHQY': '危化企业',
  'JNTS': '技能提升',
}